export default from './categories-link';



// WEBPACK FOOTER //
// ./app/containers/categories-link/index.js